<template>
  <footer class="footer_wrap" v-if="pageType != 'about'">
    <div class="footer_container">
      <div class="footer_top" :class="footerTopClass" ref="footerTopRef">
        <div class="footer_top_title">{{ footerTopTitle }}</div>
        <div class="footer_top_info">{{ footerTopInfo }}</div>
      </div>
      <!-- 底部版权信息 -->
      <div class="footer_bottom" v-show="showFooterBottom">
        <div class="copyright">
          <p>©2026中碳普惠云科技有限公司版权所有</p>
        </div>
        <div class="footer_legal">
          <p>customerservice@carbonneutrality-group.com丨<a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">沪公网安备31010102008019</a> 丨 ‍<a href="https://beian.miit.gov.cn" target="_blank">沪ICP备2024080823号-1</a></p>
        </div>
      </div>
    </div>
  </footer>
  <footer class="footer_wrap_about" v-else>
    <div class="footer_container">
      <div>
        <div class="title"><span @click="handleContact()">联系我们</span> 丨 <span @click="handleClick('product')">产品</span> 丨 <span @click="handleClick('server')">服务</span> 丨 <span @click="handleClick('home')">首页</span></div>
        <div>©2026中碳普惠云科技有限公司版权所有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">沪公网安备31010102008019</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://beian.miit.gov.cn" target="_blank">沪ICP备2024080823号-1</a></div>
        <div></div>
      </div>
      <div class="footer_container_r">
        <div class="wechat-container" 
          @mouseenter="weChatHover = true" 
          @mouseleave="weChatHover = false"
        >
          <div class="footer_container_r_item">
            <img class="footer_container_r_item_img" src="@/assets/img/home/weChat.png" alt=""/>
            微信公众号
          </div>
          <img v-if="weChatHover" class="icon_4" src="@/assets/img/home/weChat_img.png" alt="">
        </div>
        <div class="footer_container_r_item" @click="handleGoto('Douyin')">
          <img class="footer_container_r_item_img" src="@/assets/img/home/tiktok.png" alt=""/>
          官方抖音
        </div>
        <div class="footer_container_r_item" @click="handleGoto('Redbook')">
          <img class="footer_container_r_item_img" src="@/assets/img/home/redbook.png" alt=""/>
          官方小红书
        </div>
        <div class="footer_container_r_item" @click="handleGoto('Bilibili')">
          <img class="footer_container_r_item_img" src="@/assets/img/home/bilibili.png" alt=""/>
          哔哩哔哩号
        </div>
        <div class="footer_container_r_item" @click="handleGoto('Toutiao')">
          <img class="footer_container_r_item_img" src="@/assets/img/home/toutiao.png" alt=""/>
          今日头条号
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    pageType: {
      type: String,
      default: 'home'
    }
  },
  computed: {
    footerTopClass() {
      return `footer_top_${this.pageType}`;
    },
    footerTopInfo() {
      if (this.pageType === 'home') {
        return 'We Redefine the Path to Carbon Neutrality with AI';
      } else if (this.pageType === 'carbon') {
        return 'Innovative industrial civilization under climate change';
      } else if (this.pageType === 'about') {
        return 'We Redefine the Path to Carbon Neutrality with AI';
      } else if (this.pageType === 'pioneer') {
        return 'The power of communities amidst the climate crisis';
      } else if (this.pageType === 'production') {
        return 'We Redefine the Path to Carbon Neutrality with AI';
      } else if (this.pageType === 'server') {
        return 'We Redefine the Path to Carbon Neutrality with AI';
      } else {
        return 'We Redefine the Path to Carbon Neutrality with AI';
      }
    },
    footerTopTitle() {
      if (this.pageType === 'home') {
        return '我们用AI重新定义碳中和之路';
      } else if (this.pageType === 'carbon') {
        return '气候变化下的创新产业文明';
      } else if (this.pageType === 'pioneer') {
        return '气候危机下的社区力量';
      } else if (this.pageType === 'production') {
        return '我们用AI重新定义碳中和之路';
      } else if (this.pageType === 'server') {
        return 'We Redefine the Path to Carbon Neutrality with AI';
      }
    },
    handleClick() {
      return (section) => {
        let url = '';
        switch(section) {
          case 'product':
            url = 'https://ai.carbonneutrality-group.com/chat-app/';
            break;
          case 'server':
            url = '/service';
            break;
          case 'home':
            url = '/';
            break;
          default:
            url = '/';
        }
        if(section === 'product') {
         window.open(url, '_blank');
        } else {
         this.$router.push(url);
        }
      }
    },
   },
   data() {
    return {
      showFooterBottom: true,
      hasScrolled: false,
      weChatHover: false
    }
  },
  mounted() {
    // this.initObserver();
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
  methods: {
    initObserver() {
      if (this.$refs.footerTopRef) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                this.showFooterBottom = true;
              }, 1000);
            }
          });
        }, {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
        });
        
        this.observer.observe(this.$refs.footerTopRef);
      } else {
        setTimeout(() => {
          this.showFooterBottom = true;
        }, 1000);
      }
    },
    handleContact() {
        const text = "customerservice@carbonneutrality-group.com";
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(() => {
            this.$message({
              message: '客服邮箱复制成功',
              type: 'success'
            });
          }).catch(() => {
            this.fallbackCopyTextToClipboard(text);
          });
        } else {
          this.fallbackCopyTextToClipboard(text);
        }
    },
    fallbackCopyTextToClipboard(text) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      try {
          const successful = document.execCommand('copy');
          if (successful) {
            this.$message({
                message: '客服邮箱复制成功',
                type: 'success'
            });
          } else {
            this.$message({
                message: '客服邮箱复制失败，请手动复制',
                type: 'error'
            });
          }
      } catch (err) {
          console.error('Fallback: Oops, unable to copy', err);
      }
      document.body.removeChild(textarea);
    },
    handleGoto(platform) {
      let url = '';
      switch(platform) {
        case 'Douyin':
          url = 'https://www.douyin.com/user/self?from_tab_name=main';
          break;
        case 'Redbook':
          url = 'https://www.xiaohongshu.com/login?redirectPath=https%3A%2F%2Fwww.xiaohongshu.com%2Fuser%2Fprofile%2F67e66480000000001703fa39%3FexSource%3D';
          break;
        case 'Bilibili':
          url = 'https://space.bilibili.com/3546913903217483?spm_id_from=333.1007.0.0';
          break;
        case 'Toutiao':
          url = 'https://www.toutiao.com/c/user/token/Cis07dp9cdaa2Lsvq_purTSewzHkg9KmSQ1HtnzaYO92EP6GVNhAm-uqyYYkGkkKPAAAAAAAAAAAAABP1e3RCEsYL1hUroiF_UDGt5MP886g1aZFOZu88RJZzYSdzyBsTZq8xybOU3sJUGCgCRCYn4QOGMPFg-oEIgED_KQ0mg==/?source=list&log_from=21ccb1e035f1f_1765783957842';
          break;
        default:
          url = '/';
      }
      window.open(url, '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
.footer_wrap {
  width: 100%;

  .footer_container{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #000;

    .footer_top{
        width: 100%;
        height: calc(100vh * 195 / 1080);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .footer_top_title{
            font-family: Inter;
            font-weight: 700;
            font-size: 52px;
            color: #fff;
            letter-spacing: 10px;
            line-height: 52px;
        }

        .footer_top_info{
            font-family: Inclusive Sans;
            font-weight: 400;
            font-size: 28px;
            line-height: 28px;
            letter-spacing: 7px;
            color: #fff;
        }
    }

    // 首页背景色
    .footer_top_home {
        background: linear-gradient(360deg, #8EFFD8 0%, #66BCFD 100%);
    }

    // 双碳页面背景色
    .footer_top_carbon {
        background: linear-gradient(360deg, rgba(24, 255, 226, 0.9) 0%, rgba(36, 199, 205, 0.9) 100%);
    }

    // 先锋页面背景色
    .footer_top_pioneer {
        background: linear-gradient(360deg, rgba(45, 254, 228, 0.8) 0%, rgba(58, 206, 211, 0.8) 100%);
    }

    // 生产页面背景色
    .footer_top_production {
        background: linear-gradient(360deg, rgba(68, 255, 176, 0.9) 0%, rgba(51, 214, 169, 0.9) 100%);
    }

    // 服务页面背景色
    .footer_top_server {
        background: linear-gradient(360deg, #EF476F 0%, #FFD166 100%);
    }

    // 默认背景色（当pageType不匹配时）
    .footer_top_default {
        background: linear-gradient(360deg, #66FBBD 0%, #66BCFD 100%);
    }

    .footer_bottom{
      width: 100%;
      height: calc(100vh * 75 / 1080);
      font-size: 16px;
      background: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      a{
        color: #000;
        text-decoration: none;
      }
    }
  }
}

.footer_wrap_about{
  position: absolute;
  left: 0;
  top: calc(100vh * 1822 / 1080);
  width: 100%;
  height: calc(100vh * 140 / 1080);
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #2C5E68 0%, #5D8AA0 100%);

  .footer_container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: (calc(100vw * 1600 / 1920));
    height: 100%;
    color:#fff;
    font-size: 16px;
    font-weight: 300;
    line-height: 28px;

    .footer_container_r{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      width: (calc(100vw * 550 / 1920));

      .wechat-container {
        position: relative;
        display: inline-block;
        
        .icon_4 {
          position: absolute;
          top: -15px;
          left: -100px;
          width: 91px;
          height: 121px;
          z-index: 10;
        }
      }

      .footer_container_r_item{
        margin-right: 50px;
        margin-top: 12px;
        display: flex;
        justify-content: center;
        align-items: center;
        white-space: nowrap;
        cursor: pointer;

        .footer_container_r_item_img{
          width: 32px;
          height: 32px;
          margin-right: 12px;
        }
      }

      
    }

    a{
      color: #fff!important;
      text-decoration: none;
    }

    .title{
      font-size: 16px;
      font-weight: 300;
      line-height: 36px;
      cursor: pointer;
    }

    .footer_container_img{
      width: 187px;
      height: 180px;
    }
  }
}
</style>